import { createContext, Fragment, useState } from 'react'

import { Visibility } from 'globalTypes'
import ReactSlidingPane from 'react-sliding-pane'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faClose } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Trans } from '@lingui/macro'

import AssociateContents from './AssociateContents'
import styles from './index.module.css'

interface Collection {
  id: string
  visibility: Visibility
}

interface CollectionModule {
  collectionId: string
  moduleId: string
  visibility: Visibility
}

interface ContextProps {
  collection?: Collection
  setCollection: Function
  setCollectionModule: Function
}

export const Context = createContext<ContextProps>({
  collection: undefined,
  setCollection: () => {},
  setCollectionModule: () => {},
})
Context.displayName = 'AssociationContext'

export const Provider = Context.Provider
export const Consumer = Context.Consumer

interface Props {
  children: React.ReactNode | React.ReactNode[]
  refetch: Function
  totalUserContents: Number
}

library.add(faClose)

const AssociationContext = ({
  children,
  refetch,
  totalUserContents,
}: Props) => {
  const [collection, setCollection] = useState<Collection | undefined>(
    undefined
  )

  const [collectionModule, setCollectionModule] = useState<
    CollectionModule | undefined
  >(undefined)

  const value = {
    collection,
    setCollection,
    setCollectionModule,
  }

  const isOpen =
    typeof collection !== 'undefined' || typeof collectionModule !== 'undefined'

  return (
    <Fragment>
      <Provider value={value}>{children}</Provider>
      {isOpen && (
        <ReactSlidingPane
          title={
            <span className="text-2xl">
              <Trans>Contenuti della Collezione/Corso</Trans>
            </span>
          }
          from="bottom"
          isOpen={isOpen}
          onRequestClose={() => {
            refetch()
            setCollection(undefined)
            setCollectionModule(undefined)
          }}
          overlayClassName="z-30 w-screen"
          className={styles.headerButton}
          shouldCloseOnEsc
          width="100%"
          closeIcon={<FontAwesomeIcon icon={['fas', 'close']} />}
        >
          <AssociateContents
            id={collection?.id ?? collectionModule.collectionId}
            moduleId={collectionModule?.moduleId}
            totalUserContents={totalUserContents}
          />
        </ReactSlidingPane>
      )}
    </Fragment>
  )
}

export default AssociationContext
